'use strict';

/**
 * @classname AnchorSearchCondition
 * @classdesc 絞り込み条件削除
 */
export default class AnchorSearchCondition {
	/**
	 * @constructor
	 * @param {jQuery} $e - .anchor--search-condition
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._name = $e.attr('data-name');
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof AnchorSearchCondition
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		const $modal = $('#modal-filter');
		if(this._name === 'keyword') {
			$modal.find('[name=keyword]').val('');
		}else if(this._name === 'price_range'){
			$modal.find('[name=price_range]').val('');
		}else if(this._name.match(/^tag/)){
			$modal.find(`[id=${this._name}]`).prop('checked', false);
		}
		this._$e.remove();
		$('#form-product-list-menu-sp').submit();
	};
};
